
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comment-ca-marche",
      function () {
        return require("private-next-pages/comment-ca-marche/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comment-ca-marche"])
      });
    }
  